import {
  BookingsQueryParams,
  WixOOISDKAdapter,
} from '@wix/bookings-adapter-ooi-wix-sdk';
import {
  getUrlQueryParamValue,
  Referrals,
} from '@wix/bookings-catalog-calendar-viewer-utils';
import { IWixAPI } from '@wix/yoshi-flow-editor';

export const extractQueryParamValues = ({
  wixCodeApi,
  wixSdkAdapter,
  queryParam,
  isUseUtilsInsteadOfWixSDKEnabled,
}: {
  wixSdkAdapter: WixOOISDKAdapter;
  queryParam: BookingsQueryParams;
  wixCodeApi: IWixAPI;
  isUseUtilsInsteadOfWixSDKEnabled: boolean;
}): string[] => {
  const queryParamValues = isUseUtilsInsteadOfWixSDKEnabled
    ? getUrlQueryParamValue(wixCodeApi, queryParam)
    : wixSdkAdapter.getUrlQueryParamValue(queryParam);

  if (queryParamValues) {
    const queryParamValuesArray = queryParamValues.split(',');
    return queryParamValuesArray.map((value) => value.trim());
  }

  return [];
};

export const isBackFromFormWithCart = (wixCodeApi: IWixAPI) => {
  const referral = getUrlQueryParamValue(
    wixCodeApi,
    BookingsQueryParams.REFERRAL,
  );

  return referral === Referrals.BOOKINGS_FORM_WIDGET_WITH_CART;
};
